"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfValidateOtpDto = instanceOfValidateOtpDto;
exports.ValidateOtpDtoFromJSON = ValidateOtpDtoFromJSON;
exports.ValidateOtpDtoFromJSONTyped = ValidateOtpDtoFromJSONTyped;
exports.ValidateOtpDtoToJSON = ValidateOtpDtoToJSON;
exports.ValidateOtpDtoToJSONTyped = ValidateOtpDtoToJSONTyped;
/**
 * Check if a given object implements the ValidateOtpDto interface.
 */
function instanceOfValidateOtpDto(value) {
    return true;
}
function ValidateOtpDtoFromJSON(json) {
    return ValidateOtpDtoFromJSONTyped(json, false);
}
function ValidateOtpDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'otp': json['otp'] == null ? undefined : json['otp'],
    };
}
function ValidateOtpDtoToJSON(json) {
    return ValidateOtpDtoToJSONTyped(json, false);
}
function ValidateOtpDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'phone': value['phone'],
        'email': value['email'],
        'otp': value['otp'],
    };
}
